module.exports = __webpack_public_path__ + "static/media/Amazon.11b7f5e9.png";